import { object, string } from 'yup';
import type { FormikProps } from 'formik';

import {
  APPOINTMENTS_INTERVIEW_TYPES,
  APPOINTMENTS_TYPES,
} from '@shared/types/appointment';

import type { TAppointmentTemplate } from '@shared/types/appointment-template';
import type { TAppointmentFormValues } from './appointment';

export const appointmentTemplateFormNames = {
  name: 'name',
  description: 'description',
  interviewType: 'interviewType',
  appointmentType: 'appointmentType',
} as const;

export const appointmentTemplateFormInitialValues = {
  name: '',
  description: '',
  interviewType: '' as TAppointmentTemplate['interview_type'],
  appointmentType: '' as TAppointmentTemplate['type'],
};

export const createInitialValueFromExistingAppointmentTemplate = (
  appointmentTemplateData?: TAppointmentTemplate
) => {
  if (!appointmentTemplateData) return undefined;

  return {
    name: appointmentTemplateData.name,
    description: appointmentTemplateData.description,
    interviewType: appointmentTemplateData.interview_type,
    type: appointmentTemplateData.type,
  };
};

export const createInitialValueFromExistingAppointmentForm = (
  formik?: FormikProps<TAppointmentFormValues>
) => {
  if (!formik) return undefined;

  return {
    name: '',
    description: formik?.values.description || '',
    interviewType: formik?.values.interviewType || '',
    appointmentType: formik?.values.appointmentType || '',
  };
};

export const appointmentTemplateFormSchema = object().shape({
  name: string().required('Please enter name for a template'),
  description: string().required('Please enter description for a template'),

  interviewType: string()
    .oneOf(
      Object.values(APPOINTMENTS_INTERVIEW_TYPES),
      `Interview type must be either ${Object.values(APPOINTMENTS_INTERVIEW_TYPES).join(', ')}`
    )
    .required('Interview type is required'),

  appointmentType: string()
    .oneOf(
      Object.values(APPOINTMENTS_TYPES),
      `type must be either ${Object.values(APPOINTMENTS_TYPES).join(', ')}`
    )
    .required('Appointment type is required'),
});

export type TAppointmentTemplateFormValues =
  typeof appointmentTemplateFormInitialValues;
